import React, { useEffect, useRef, useState } from "react";
import Input, { InputProps } from "antd/lib/input";
import { generateUniqueUrl } from "../../helpers/generateUniqueUrl";
import _ from "lodash";
import { Modal } from "antd";
import { getActiveDomain } from "../../helpers/websites/getActiveDomain";
import { connect } from "react-redux";
import { getCurrentStoreData } from "../../store/websites/thunks";
import { GetCurrentStoreData } from "../../store/websites/types";
import { pageUrlUpdateErrorMessage } from "../../store/websitePages/actions";
import PageTemplatesList from "./PageTemplatesList";
import "./PageTemplate.scss";
import "./SettingsBox.css";

interface UrlInputProps extends InputProps {
  urlInputValue: string;
  setUrlInputValue: (value: string) => void;
  currentWebsitePages: any;
  websitesPages: any;
  currentWebsite: any;
  pageUrlUpdateErrorMessage: (message: string) => void;
}
const UrlInput = (props: UrlInputProps) => {
  const {
    urlInputValue,
    setUrlInputValue,
    currentWebsitePages,
    websitesPages,
    currentWebsite,
    pageUrlUpdateErrorMessage,
    ...nativeProps
  } = props;
  const inputRef = useRef<Input>(null);

  useEffect(() => {
    let pageUrl = generateUniqueUrl("untitled", currentWebsitePages);
    const currentHomePage = websitesPages.items
      .filter((page) => {
        return page.website === _.get(currentWebsite, "id");
      })
      .find((page) => {
        return page.url === "";
      });
    if (!currentHomePage) {
      pageUrl = "";
    }

    setUrlInputValue(pageUrl);

    if (inputRef && inputRef.current && inputRef.current.select) {
      setTimeout(() => {
        inputRef.current.select();
      }, 0);
    }

    const handlePressEnter = (e) => {
      if (e.key === "Enter") {
        if (inputRef && inputRef.current && inputRef.current.blur) {
          inputRef.current.blur();
        }
      }
    };
    window.addEventListener("keypress", handlePressEnter);
    return () => {
      window.removeEventListener("keypress", handlePressEnter);
    };
  }, []);

  useEffect(() => {
    pageUrlUpdateErrorMessage("");
    return () => {
      pageUrlUpdateErrorMessage("");
    };
  }, [urlInputValue]);

  return (
    <Input
      {...nativeProps}
      ref={inputRef}
      value={urlInputValue}
      onChange={(e) => {
        setUrlInputValue(e.target.value);
      }}
    ></Input>
  );
};

interface Props {
  isPageModalVisible: boolean;
  handlePagesModalCancel: () => void;
  currentWebsitePages: any;

  websitesPages: any;
  pageUrlUpdateErrorMessage: any;
  getCurrentStoreData: GetCurrentStoreData;
}
const PageTemplatesModal = (props: Props) => {
  const {
    isPageModalVisible,
    handlePagesModalCancel,
    getCurrentStoreData,
    websitesPages,
    currentWebsitePages,
  } = props;
  const [urlInputValue, setUrlInputValue] = useState("");
  const { currentWebsite, currentWebsitePage } = getCurrentStoreData();
  return (
    <Modal
      visible={isPageModalVisible}
      onCancel={handlePagesModalCancel}
      centered
      title="Add new page"
      footer={null}
      width={"100%"}
      className="page-templates"
      destroyOnClose
      style={{ maxWidth: 1200, padding: "0 16px" }}
    >
      <div>
        <div style={{ marginBottom: 24, maxWidth: 460, width: "100%" }}>
          <UrlInput
            addonBefore={
              <div
                style={{
                  maxWidth: "150px",
                  direction: "rtl",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {getActiveDomain(currentWebsite)}/&lrm;
              </div>
            }
            style={{ width: "100%" }}
            defaultValue="untitled"
            placeholder="about-us"
            urlInputValue={urlInputValue}
            setUrlInputValue={setUrlInputValue}
            currentWebsitePages={currentWebsitePages}
            currentWebsite={currentWebsite}
            websitesPages={websitesPages}
            pageUrlUpdateErrorMessage={props.pageUrlUpdateErrorMessage}
          />
          <div
            className="settings-box__error_message"
            style={{
              opacity:
                websitesPages.pageUrlUpdateErrorMessage === undefined ? 0 : 1,
            }}
          >
            {websitesPages.pageUrlUpdateErrorMessage}
          </div>
        </div>
        {/* <PageTemplatesList
          onSuccess={handlePagesModalCancel}
          currentPageUrl={urlInputValue}
          setUrlInputValue={setUrlInputValue}
        /> */}
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => {
  return {
    websitesPages: state.websitesPages,
  };
};
export default connect(mapStateToProps, {
  getCurrentStoreData,
  pageUrlUpdateErrorMessage,
})(PageTemplatesModal);
